"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntoTheShadowsAbilityHandler = exports.IntoTheShadowsActorAbilityFactory = exports.IntoTheShadowsAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
class IntoTheShadowsAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.IntoTheShadows;
        this.__typeName = "IntoTheShadows";
    }
}
exports.IntoTheShadowsAbilityArgs = IntoTheShadowsAbilityArgs;
let IntoTheShadowsActorAbilityFactory = class IntoTheShadowsActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("IntoTheShadows", "Self", 4);
    }
};
IntoTheShadowsActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("IntoTheShadows")
], IntoTheShadowsActorAbilityFactory);
exports.IntoTheShadowsActorAbilityFactory = IntoTheShadowsActorAbilityFactory;
let IntoTheShadowsAbilityHandler = class IntoTheShadowsAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.removeDebuffs({
                    sequence,
                    removerId: ability.invokerId,
                    targets: [{
                            targetId: ability.invokerId,
                            includeSupernatural: false
                        }]
                });
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Toughness, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Toughness"))
                });
            }
        });
    }
};
IntoTheShadowsAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.IntoTheShadows)
], IntoTheShadowsAbilityHandler);
exports.IntoTheShadowsAbilityHandler = IntoTheShadowsAbilityHandler;
